module.exports = __webpack_public_path__ + "assets/img/bg_header_01.34641fc4.gif";